import { render, staticRenderFns } from "./rebateTradeDetails.vue?vue&type=template&id=b78359a2"
import script from "./rebateTradeDetails.vue?vue&type=script&lang=js"
export * from "./rebateTradeDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports